export enum Category {
    WRITTEN = 1,
    ORAL= 2,
    PRACTICAL = 3
}